import { render, staticRenderFns } from "./ManagementRootView.vue?vue&type=template&id=243fb47c"
import script from "./ManagementRootView.vue?vue&type=script&lang=js"
export * from "./ManagementRootView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports